export enum BrowserSupportFeatures {
  Voice = 'Voice',
  Video = 'Video',
  Screenshot = 'Screenshot',
}
